'use strict';
import {InfobipApiData, InfobipApiCall} from '../components/infobipApi';

export default class FormPrizePage2023 {

    constructor() {

        let form = document.getElementById('form-prize-page-2023');
        $('.form-prize-page-2023__confirmation').hide();
        // is the element present on the current page
        if (!form) {
            return;
        }

        //upload file input
        const inputFile = document.getElementById('invoice');
        if(inputFile) {
            inputFile.addEventListener('change', () => {
                readURL(inputFile);
            });
            //Remove file
            const removeFile = document.querySelector('.remove-image');
            removeFile.addEventListener('click', () => {
                removeUpload();
            });
        }

        function readURL(input) {
            if (input.files && input.files[0]) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    $('.image-upload-wrap').hide();

                    $('.file-upload-image').attr('src', e.target.result);
                    $('.file-upload-content').show();

                    $('.image-title').html(input.files[0].name);
                };

                reader.readAsDataURL(input.files[0]);

            } else {
                removeUpload();
            }
        }

        function removeUpload() {
            //$('.file-upload-input').replaceWith($('.file-upload-input').clone());
            $('.file-upload-content').hide();
            $('.image-upload-wrap').show();
            $('.file-upload-input').val(null);
        }
        $('.image-upload-wrap').bind('dragover', function () {
            $('.image-upload-wrap').addClass('image-dropping');
        });
        $('.image-upload-wrap').bind('dragleave', function () {
            $('.image-upload-wrap').removeClass('image-dropping');
        });



        let input = form.querySelector('input[type="file"]'),
            label = form.querySelector('label'),
            submit = form.querySelector('#submitFormPrizePage2023'),
            errorMsg = form.querySelector('.form-group__file .invalid-feedback');


           $("input").click(function(){
                 console.log("On change function");
                $(this).parent().removeClass('has-errors');
                $(this).parent().siblings('.invalid-feedback').slideUp();
                $(this).siblings('.invalid-feedback').slideUp();
            });

        // if the form was submitted
        form.addEventListener('submit', e => {
            const eventsubmit = 'form-submit-' + $('.form #language').val() + '-form-prize-page-2023';
            const eventsent = 'form-sent-' + $('.form #language').val() + '-form-prize-page-2023';
            console.log(eventsubmit);
            console.log(eventsent);

                if (!$('#form-prize-page-2023')[0].checkValidity()) {
                    e.preventDefault();

                    $('input, textarea').each(function () {

                        if (!this.checkValidity()) {
                            $(this).parent().addClass('has-errors');

                            // Checkbox
                            $(this).siblings('.invalid-feedback').slideDown();

                            // Other elements
                            $(this).parent().siblings('.invalid-feedback').slideDown();
                        } else {
                            $(this).parent().removeClass('has-errors');
                            $(this).parent().siblings('.invalid-feedback').slideUp();
                            $(this).siblings('.invalid-feedback').slideUp();
                        }
                    });

                } else {
                    e.preventDefault();

                    //Events tracking
                    //ga('send', 'event', eventsubmit, eventsubmit, 'webpage');
                   // plausible(eventsubmit);

                    if( $('.form #invoice').length) {
                        var file_data = $('.form #invoice').prop('files')[0];
                    } else {
                        var file_data = null;
                    }


                    var ajaxData = new FormData()

                    ajaxData.append('action', 'form_prize');
                    ajaxData.append('name', $('.form #name').val());
                    ajaxData.append('last', $('.form #last').val());
                    ajaxData.append('email', $('.form #email').val());
                    ajaxData.append('address', $('.form #address').val());
                    ajaxData.append('city', $('.form #city').val());
                    ajaxData.append('postal', $('.form #postal_code').val());
                    ajaxData.append('vatid', $('.form #vat_id').val());
                    ajaxData.append('invoice', file_data);
                    ajaxData.append('invoice_selected', $('.form #invoice_selected').val());
                    ajaxData.append('id', $('.form #id').val());
                    ajaxData.append('nonce', $('.form #nonce').val());
                    ajaxData.append('pageid', $('.form #pageid').val());

                    //console.log("Form Data: ", ajaxData)


                    $.ajax({
                        url: window.location.origin + '/wp/wp-admin/admin-ajax.php',
                        data: ajaxData,
                        processData: false,
                        contentType: false,
                        type: 'POST',
                        success: function (data) {
                            $('#form-prize-page-2023').hide();
                            //document.querySelector('.logo').style.backgroundImage = 'url(/app/themes/argeta-timber/dist/images/svg/logo-argeta-orange.svg)';
                            $('.form-prize-page-2023__confirmation').show();
                            $('.form-prize-page-2023__email_exist').hide();
                            $('#form-head').hide();
                            $('#form-head-description').hide();
                            $('#form-head-message').hide();

                            //Infobip integration
                           const wrapper = $('#subscribe-form');

                            const target = $("#submitFormPrizePage2023").attr("data-infobip-submit");

                            //Getname
                            const getname = wrapper.find("[data-infobip='"+target+"'] input[name=name]").val();

                            //Get last name
                            const getlastname = wrapper.find("[data-infobip='"+target+"'] input[name=last]").val();

                            //Get email
                            const getemail = wrapper.find("[data-infobip='"+target+"'] input[name=email]").val();

                            //Get address
                            const getaddress = wrapper.find("[data-infobip='"+target+"'] input[name=address]").val();

                            //Get city
                            const getcity = wrapper.find("[data-infobip='"+target+"'] input[name=city]").val();

                            //Get postal code
                            const getpostal = wrapper.find("[data-infobip='"+target+"'] input[name=postal_code]").val();

                            //Get vat id
                            const getvatid = wrapper.find("[data-infobip='"+target+"'] input[name=vat_id]").val();

                            //Get date
                            const date = new Date();
                            var datestring = date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();

                            //Get language
                            const getlanguage = wrapper.find("[data-infobip='"+target+"'] input[name=language]").val();

                            //Get country
                            const getcountry = wrapper.find("[data-infobip='"+target+"'] input[name=country]").val();

                            //Send to infobip if GDPR is checked
                           /* if(getgdprChecked.prop("checked") === true) {
                                const infobipData = new InfobipApiData(
                                    getname ? getname : null,
                                    getlastname ? getlastname : null,
                                    getaddress ? getaddress : null,
                                    getcity ? getcity : null,
                                    getcountry ? getcountry : "",
                                    null,
                                    null,
                                    getpostal ? getpostal : null,
                                    getlanguage ? getlanguage : "",
                                    "Proze form 2023",
                                    "Argeta",
                                    null,
                                    null,
                                    date ? datestring : "",
                                    date ? datestring : "",
                                    null,
                                    true,
                                    null,
                                    null,
                                    null,
                                    true,
                                    false,
                                    false,
                                    false,
                                    true,
                                    getemail ? getemail : null,
                                    null);

                                 console.log("Infobip call: ",infobipData);

                                 InfobipApiCall(infobipData);

                            }*/

                            //Events tracking
                            //ga('send', 'event', eventsent, eventsent, 'webpage');
                            //plausible(eventsent);

                            $([document.documentElement, document.body]).animate({
                                scrollTop: $(".form-prize-page-2023__confirmation").offset().top - 80
                            }, 500);

                            /*$([document.documentElement, document.body]).animate({
                                scrollTop: 0
                            }, 1000);*/
                        },
                        error: function (error) {
                            console.log(error.responseJSON.data.error);
                            $('.form-prize-page-2023__email_exist').slideDown();
                        }
                    });

                }
        });

    }
}
